/** Whether the session user is a Leap admin (demo mode + admin-only features). */
export function isAdminUser(user) {
  if (!user) return false;
  const role = String(user.role || '').toLowerCase();
  const jobTitle = String(user.jobTitle || user.job_title || '').toLowerCase();
  return role === 'admin' || jobTitle === 'admin';
}
